/*eslint-disable*/
import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Grid from '@material-ui/core/Grid';
import contactUsStyle from "assets/jss/CustomerTradePortal/views/contactUsPageStyle.js";
import 'trade-customer-portal/views/ContactUsPage/StyleSheet.css';
/*import BingMapsReact from "bingmaps-react";*/
import { FiMapPin, FiPhone, FiMail, FiClock } from "react-icons/fi";
import FooterSection from "trade-customer-portal/views/footer.js";
import HeaderSection from "trade-customer-portal/views/header.js";
import ContactInput from "./Classes/ContactInput";
import JSFile from '../../../../../ClientApp/package.json';
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Parallax from "components/Parallax/Parallax.js";
const useStyles = makeStyles(contactUsStyle);

export default function ContactUsPage() {
    React.useEffect(() => {
        window.scrollTo(0, 0);
        document.body.scrollTop = 0;
    });
    const classes = useStyles();



    return (
        <div>
            <HeaderSection />


            <Parallax
                image={require("assets/img/contact-us-banner.jpg")}
                filter="dark"
                xsmall
            >
                <div className={classes.container}>
                    <GridContainer justify="center">
                        <GridItem
                            md={7}
                            sm={8}
                            className={classNames(
                                classes.mlAuto,
                                classes.mrAuto,
                                classes.textCenter
                            )}
                        >
                            <h1 className={classes.title}>Contact Us</h1>
                        </GridItem>
                    </GridContainer>

                </div>
            </Parallax>

            <div className={classNames(classes.main, classes.mainRaised)}>
                <div className={classes.contactContent}>
                    <div className={classes.container}>
                        <h1 className={classes.title2} >Send us a message</h1>
                        <ContactInput />
                    </div>

                    <div>
                        <Grid container spacing={1} style={{ padding: "15px" }}>
                            <Grid item md={3} sm={3} xs={12}>
                                <div className="container">
                                    <div className="card">
                                        <div className="circle c-3"><FiMapPin color='white' /></div>
                                        <div className="info">
                                            <h3> <b> OUR LOCATION </b></h3>
                                            <h4>
                                                Brascote Lane, Cadeby<br /> Warwickshire,{" "} <br />
                                                CV13 0BB. GB</h4>
                                        </div>
                                    </div>
                                </div>
                            </Grid>
                            <Grid item md={3} sm={3} xs={12}>
                                <div className="container">
                                    <div className="card">
                                        <div className="circle c-1"> <FiClock color='white' /> </div>
                                        <div className="info">
                                            <h3> <b> OPENING TIMES </b></h3>
                                            <h4>Mon-Fri: 08:30 - 17:30 <br />Saturday: 09:00 - 13:00</h4>
                                        </div>
                                    </div>
                                </div>
                            </Grid>
                            <Grid item md={3} sm={3} xs={12}>
                                <div className="container">
                                    <div className="card">
                                        <a href="tel:01455 292189" style={{ color: 'black' }}>
                                            <div className="circle c-2"><FiPhone color='white' /></div>
                                            <div className="info">
                                                <h3><b> TELEPHONE </b></h3>
                                                <h4>Tel 1: 01455 292189 <br /> Tel 2: 01455 290780 </h4>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </Grid>
                            <Grid item md={3} sm={3} xs={12}>
                                <div className="container">
                                    <div className="card">
                                        <a href="mailto:sales@fpmccann.co.uk" style={{ color: 'black' }}>
                                            <div className="circle c-4"><FiMail color='white' /></div>
                                            <div className="info">
                                                <h3><b>E-MAIL </b></h3>
                                                <h4> sales@fpmccann.co.uk <br /> {" "} </h4>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </Grid>
                        </Grid>

                    </div>
                </div>

            </div>
            <FooterSection />
        </div>
    );
}
